interface Props {
    className?: string;
}

export function CloseCircleIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 2C6.70156 2 2 6.70156 2 12.5C2 18.2984 6.70156 23 12.5 23C18.2984 23 23 18.2984 23 12.5C23 6.70156 18.2984 2 12.5 2ZM16.3766 16.4891L14.8297 16.482L12.5 13.7047L10.1727 16.4797L8.62344 16.4867C8.52031 16.4867 8.43594 16.4047 8.43594 16.2992C8.43594 16.2547 8.45234 16.2125 8.48047 16.1773L11.5297 12.5445L8.48047 8.91406C8.45215 8.87971 8.43643 8.8367 8.43594 8.79219C8.43594 8.68906 8.52031 8.60469 8.62344 8.60469L10.1727 8.61172L12.5 11.3891L14.8273 8.61406L16.3742 8.60703C16.4773 8.60703 16.5617 8.68906 16.5617 8.79453C16.5617 8.83906 16.5453 8.88125 16.5172 8.91641L13.4727 12.5469L16.5195 16.1797C16.5477 16.2148 16.5641 16.257 16.5641 16.3016C16.5641 16.4047 16.4797 16.4891 16.3766 16.4891Z"
                fill="currentColor"
            />
        </svg>
    );
}
